// @flow
import type { TabItem } from "./index";

/**
 * TabItems relevant for displaying basketball markets
 *
 * @ignore
 */
const BasketballTabItems: [TabItem] = [
  {
    index: 0,
    title: "main",
    filteringType: "include",
    displayByCategoryOrder: false,
    categories: [
      "total points",
      "handicap 2",
      "match result",
      "first team to score",
      "last team to score",
      "money line",
      "highest scoring",
      "last score",
      "double result",
      "both halves result"
    ],
  },
  {
    index: 1,
    title: "players",
    filteringType: "include",
    displayByCategoryOrder: false,
    categories: ["player", "first basket", "last basket"],
  },
  {
    index: 2,
    title: "points",
    filteringType: "include",
    displayByCategoryOrder: false,
    categories: ["race to", "total points", "handicap 2"],
  },
  {
    index: 3,
    title: "team",
    filteringType: "include",
    displayByCategoryOrder: false,
    categories: ["last score", "score type", "team"],
  },
  {
    index: 4,
    title: "other",
    filteringType: "include",
    displayByCategoryOrder: false,
    categories: [],
  },
];

export { BasketballTabItems };



// WEBPACK FOOTER //
// ./src/model/basketball.js